// extracted by mini-css-extract-plugin
module.exports = {"textAreaBox":"formRemarks_textAreaBox__35a6j","textAreaCount":"formRemarks_textAreaCount__33HRT"};